export const subjects = [
  { key: "sub-nta", value: "New to the area", text: "New to the area" },
  { key: "sub-info", value: "Information", text: "Information" },
  { key: "sub-transfer", value: "Transfer", text: "Transfer" },
  { key: "sub-other", value: "Other", text: "Other" }
];



// WEBPACK FOOTER //
// ./src/data/getintouch.subjects.data.js